var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"content"}},[_c('PageTitle',{attrs:{"title":"Invoices"}}),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-content animated fadeInRight"},[_c('ListInvoices')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }